import { FC, useEffect, useRef, useState } from 'react';

import { Modal } from '@components/uiKit/Modal';

import { FormValues } from '../../types';
import { getFieldName, isNumberArray, isPriceRangeDefault } from '../../utils';
import PopupFormContent from './components/PopupFormContent';
import styles from './FiltersPopup.module.scss';
import { FiltersPopupProps } from './types';

const FiltersPopup: FC<FiltersPopupProps> = ({
    isOpen,
    onClose,
    filterData,
    hidePriceFilter,
    isBrandPage = false,
    priceRange,
    fieldsWithSearch,
    fieldPrefix,
    preExpanded,
    rangeDefault,
    filterValues,
    onApplyFilters,
    baseFilters,
    onApplyClick,
}) => {
    const isMobile = fieldPrefix === 'mobile';
    const newFilterData = [...filterData];

    const prevIsOpenRef = useRef<boolean>(false);
    const [formKey, setFormKey] = useState<string>('');
    const [popupInitialValues, setPopupInitialValues] = useState<FormValues>({});

    useEffect(() => {
        if (isOpen && !prevIsOpenRef.current) {
            const newFormKey = `popup-form-${Date.now()}-${Math.random()}`;
            const values: FormValues = {};

            filterData.forEach(filterField => {
                const fieldName = getFieldName(String(filterField.code), fieldPrefix);

                if (filterValues?.filters) {
                    const filterCode = String(filterField.code);
                    const filterValue = filterValues.filters[filterCode];
                    values[fieldName] = filterValue || [];
                } else if (Array.isArray(filterField.values)) {
                    values[fieldName] = [];
                }
            });

            if (!hidePriceFilter) {
                const priceFieldName = getFieldName('price', fieldPrefix);
                const priceValue = filterValues?.filters?.price;
                const savedPrice = priceValue !== undefined && isNumberArray(priceValue) ? priceValue : undefined;

                if (savedPrice) {
                    const [min, max] = savedPrice;
                    if (!isPriceRangeDefault(min, max, priceRange)) {
                        values[priceFieldName] = savedPrice;
                    }
                }
            }

            const isPreOrderFieldName = getFieldName('popup_isPreOrder', fieldPrefix);

            if (filterValues?.filters?.isPreOrder === false) {
                values[isPreOrderFieldName] = true;
            } else {
                values[isPreOrderFieldName] = filterValues?.filters?.isPreOrder || false;
            }

            setFormKey(newFormKey);
            setPopupInitialValues(values);
        }

        prevIsOpenRef.current = isOpen;
    }, [isOpen, filterData, filterValues, fieldPrefix, hidePriceFilter, priceRange]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={isMobile ? 'Фильтры' : 'Все фильтры'}
            mobileType={isMobile ? 'fullWidth' : 'centered'}
            withIconBack={isMobile}
            onBack={onClose}
            width={isMobile ? undefined : 1200}
            closeButtonAriaLabel="Закрыть"
            className={isMobile ? styles.modalMobile : styles.modalDesktop}
            customCss={{ contentClassName: styles.content }}
        >
            <PopupFormContent
                key={formKey}
                initialValues={popupInitialValues}
                onApplyFilters={onApplyFilters}
                onClose={onClose}
                filterData={newFilterData}
                hidePriceFilter={hidePriceFilter}
                isBrandPage={isBrandPage}
                priceRange={priceRange}
                fieldsWithSearch={fieldsWithSearch}
                fieldPrefix={fieldPrefix}
                preExpanded={preExpanded}
                rangeDefault={rangeDefault}
                formKey={formKey}
                isOpen={isOpen}
                baseFilters={baseFilters}
                onApplyClick={onApplyClick}
            />
        </Modal>
    );
};

export default FiltersPopup;
